<ion-card class="apply-card">
    <ion-card-header class="card-header-starttime">
        <ion-card-title class="ion-text-center">
            <div class="application-starttime bold-text">
                {{ status?.application?.type }}<br />
                <span class="note-text"
                    >{{
                        status?.application?.startdate | date: 'longDate':'UTC'
                    }}
                    -
                    {{
                        status?.application?.enddate | date: 'longDate':'UTC'
                    }}</span
                >
            </div>
        </ion-card-title>
    </ion-card-header>
    <!-- <ion-card-content>
        <div>
            {{
                (toolService.content | async)?.application?.components?.bookNow
                    ?.notAccepting
            }}
        </div>
    </ion-card-content> -->
    <ion-card-content class="booking-content" *ngIf="!($hasBook | async)">
        <!-- hide if already booked state-->
        <div>
            <div class="book-title ion-text-center orange">
                Book now!
            </div>
            <hr class="buttons-divider" />
            <ion-list>
                <ion-item lines="none">
                    <div
                        [innerHTML]="
                            (toolService.content | async)?.application
                                ?.components?.bookNow?.cardTitle
                        "
                    ></div>
                </ion-item>
            </ion-list>
            <hr class="buttons-divider" />
        </div>
        <div class="ion-text-center">
            <ion-button
                type="button"
                [queryParams]="{
                    applicationid: status?.application?.id,
                    type: 'booking-payment'
                }"
                [routerLink]="['/payment-booking']"
                [routerDirection]="'root'"
            >
                Start Booking!
            </ion-button>
        </div>
        <!-- <div class="ion-text-center">
            <div class="cancel-text"><br />Need more time?</div>
            <ion-button
                fill="clear"
                type="button"
                (click)="exitBooking()"
                color="primary"
                class="cancel-link"
                >Go back
            </ion-button>
        </div> -->
    </ion-card-content>
    <ion-card-content *ngIf="$hasBook | async">
        <ion-list>
            <ion-item>
                <div
                    [innerHTML]="
                        (toolService.content | async)?.application?.components
                            ?.bookNow?.cardTitle
                    "
                ></div>
            </ion-item>
            <ion-item>
                <div class="incomplete-circle" slot="start">
                    <b class="circle-number-center">1</b>
                </div>
                <ion-icon
                    size="large"
                    name="checkmark"
                    slot="start"
                    color="primary"
                ></ion-icon>
                <ion-label class="ion-text-wrap">
                    <span class="bold-text highlight">{{
                        (toolService.content | async)?.application?.components
                            ?.bookNow?.verifyPaymentTitle
                    }}</span>
                    <p class="note-text text-teal">
                        Agree to pay the booking price of ${{
                            status?.application?.deposit
                        }}
                        USD once you are accepted.
                    </p>
                </ion-label>
            </ion-item>
            <ion-item>
                <div class="incomplete-circle" slot="start">
                    <b class="circle-number-center">2</b>
                </div>
                <ion-icon
                    size="large"
                    name="checkmark"
                    slot="start"
                    color="primary"
                ></ion-icon>
                <ion-label class="ion-text-wrap">
                    <span class="bold-text highlight"
                        >{{
                            (toolService.content | async)?.application
                                ?.components?.bookNow?.verifyTitle
                        }}
                    </span>
                    <p *ngIf="!showDynamicCopy" class="note-text text-teal">
                        {{
                            (toolService.content | async)?.application
                                ?.components?.bookNow?.CVVerifyDocs
                        }}
                    </p>
                    <p *ngIf="showDynamicCopy" class="note-text text-teal">
                        {{
                            (toolService.content | async)?.application
                                ?.components?.bookNow?.preAcceptanceVerifyDocs
                        }}
                    </p>
                </ion-label>
            </ion-item>
        </ion-list>
        <div
            [innerHTML]="
                (toolService.content | async)?.application?.components
                    ?.pendingBooked?.receivedApplication
            "
        ></div>
    </ion-card-content>
</ion-card>
